import { render, staticRenderFns } from "./Nuevo-presupuesto.vue?vue&type=template&id=420f4a78"
import script from "./Nuevo-presupuesto.vue?vue&type=script&lang=js"
export * from "./Nuevo-presupuesto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports